var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPtBr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 0H0V7H12.0011V0Z",
    fill: "#3C9242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85278 3.49992L6.00459 6.1506L10.1564 3.49992L6.00459 0.849243L1.85278 3.49992Z",
    fill: "#EDC226"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75049 3.5C7.75049 4.46783 6.96832 5.25 6.00049 5.25C5.03266 5.25 4.25049 4.46783 4.25049 3.5C4.25049 2.53612 5.03266 1.75 6.00049 1.75C6.96832 1.75 7.75049 2.53612 7.75049 3.5Z",
    fill: "#2D146E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00507 2.74951C4.79966 2.74951 4.59819 2.76531 4.40462 2.79297C4.36512 2.87987 4.33747 2.96678 4.30981 3.06159C4.53498 3.02208 4.76805 3.00233 5.00507 3.00233C6.03216 3.00233 6.96839 3.38947 7.6755 4.02547C7.70316 3.93461 7.72686 3.84376 7.73871 3.74895C6.99605 3.12479 6.04401 2.74951 5.00507 2.74951Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5113 2.98641C4.55081 2.98245 4.58241 2.939 4.57451 2.89555C4.57056 2.85209 4.53106 2.81654 4.49155 2.82049C4.4481 2.82444 4.42045 2.86789 4.42835 2.91135C4.4323 2.95875 4.46785 2.99431 4.5113 2.98641ZM4.50735 2.95875C4.53106 2.9548 4.54686 2.9311 4.54291 2.8995C4.53896 2.87185 4.51921 2.84814 4.49155 2.85209C4.46785 2.85604 4.45205 2.87975 4.45205 2.9074C4.45995 2.939 4.48365 2.95875 4.50735 2.95875Z",
    fill: "#3C9242"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6456 2.97466L4.6772 2.97071L4.67325 2.90751L4.7404 2.90356C4.76806 2.89961 4.78781 2.8759 4.78781 2.84825C4.78386 2.8206 4.76016 2.7969 4.7325 2.80085L4.6377 2.80875L4.6456 2.97466ZM4.6693 2.87985L4.7325 2.8759C4.74435 2.8759 4.75225 2.86405 4.75225 2.8522C4.75225 2.84035 4.7404 2.83245 4.7325 2.83245L4.6693 2.8364V2.87985Z",
    fill: "#3C9242"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78804 2.96275C4.78804 2.93905 4.78409 2.8877 4.74853 2.8877L4.70508 2.89165C4.75643 2.8877 4.76038 2.943 4.76433 2.96275",
    fill: "#3C9242"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85889 2.95888H4.93789C4.9774 2.95888 5.009 2.92728 5.009 2.88778V2.86407C5.009 2.82457 4.9774 2.79297 4.93789 2.79297H4.85889V2.95888ZM4.88654 2.92728H4.92999C4.95369 2.92728 4.97345 2.90753 4.97345 2.87988V2.86407C4.97345 2.84037 4.95369 2.82062 4.92999 2.82062H4.88259L4.88654 2.92728Z",
    fill: "#3C9242"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06836 2.95888L5.21847 2.96283V2.93123L5.09996 2.92728V2.88778H5.19477V2.86012L5.09996 2.85617V2.82457L5.21847 2.82852V2.79692L5.07626 2.79297L5.06836 2.95888Z",
    fill: "#3C9242"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28174 2.9667L5.30939 2.97065L5.31729 2.85609L5.34099 2.97065L5.36865 2.9746L5.4121 2.86399L5.40025 2.97855L5.4279 2.9825L5.4437 2.81263L5.4042 2.80868L5.36075 2.92324L5.33704 2.80473L5.29359 2.80078L5.28174 2.9667Z",
    fill: "#3C9242"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62524 3.00619L5.75165 3.02594V2.99829L5.6608 2.98249L5.66475 2.94694L5.74375 2.95879L5.7477 2.93114L5.67265 2.91928V2.89163L5.76746 2.90743L5.77141 2.87978L5.6529 2.85608L5.62524 3.00619Z",
    fill: "#3C9242"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94116 3.06951L5.96881 3.07741L5.98462 3.01816L6.04782 3.03396C6.07547 3.04186 6.10708 3.02606 6.11103 2.99841C6.11893 2.97075 6.09918 2.9431 6.07152 2.9352L5.98067 2.9115L5.94116 3.06951ZM5.99647 2.98656L6.05967 3.00236C6.07152 3.00631 6.08337 2.99841 6.08337 2.98656C6.08732 2.9747 6.07942 2.96285 6.06757 2.9589L6.00437 2.9431L5.99647 2.98656Z",
    fill: "#3C9242"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14673 3.1207L6.17833 3.1286L6.19808 3.06935L6.26129 3.0891C6.28894 3.097 6.32054 3.0812 6.32844 3.05355C6.33635 3.0259 6.32054 2.99824 6.29684 2.98639L6.20598 2.95874L6.14673 3.1207ZM6.20598 3.0417L6.26919 3.06145C6.27709 3.0654 6.29289 3.0575 6.29684 3.04565C6.30079 3.0338 6.29289 3.02195 6.28104 3.018L6.22179 2.99824L6.20598 3.0417Z",
    fill: "#3C9242"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28114 3.16431C6.28904 3.14061 6.30484 3.0932 6.26928 3.08135L6.22583 3.06555C6.27323 3.08135 6.25743 3.13271 6.25348 3.15246",
    fill: "#3C9242"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41932 3.21562C6.45883 3.23142 6.50228 3.20771 6.51808 3.16426C6.53388 3.12081 6.51808 3.0734 6.47858 3.06155C6.43907 3.04575 6.39562 3.06945 6.37982 3.11291C6.36007 3.15241 6.37982 3.19981 6.41932 3.21562ZM6.42722 3.18401C6.45092 3.19191 6.47858 3.17611 6.48648 3.15241C6.49833 3.12476 6.48648 3.09711 6.46278 3.0892C6.43907 3.0813 6.41142 3.09711 6.40352 3.12476C6.39562 3.14846 6.40747 3.17611 6.42722 3.18401Z",
    fill: "#3C9242"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61272 3.29448C6.65223 3.31028 6.69568 3.29053 6.71543 3.24707C6.73123 3.20362 6.71938 3.15622 6.67988 3.14041C6.64037 3.12461 6.59692 3.14436 6.57717 3.18782C6.56137 3.23127 6.57717 3.27868 6.61272 3.29448ZM6.62852 3.26683C6.65223 3.27868 6.67988 3.26288 6.68778 3.23522C6.69963 3.20757 6.69173 3.17992 6.66803 3.16807C6.64433 3.16017 6.61667 3.17202 6.60877 3.19967C6.59692 3.22732 6.60482 3.25497 6.62852 3.26683Z",
    fill: "#3C9242"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66029 3.22351L6.71559 3.24721L6.70769 3.27091L6.64844 3.24326L6.66029 3.22351Z",
    fill: "#3C9242"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69591 3.23535L6.71566 3.2472L6.68406 3.32226L6.66431 3.31436L6.69591 3.23535Z",
    fill: "#3C9242"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.73926 3.34994L6.76691 3.36179L6.79456 3.30649L6.85382 3.33809C6.88147 3.34994 6.90912 3.34204 6.92492 3.31439C6.93678 3.28674 6.92887 3.25513 6.90122 3.24328L6.81826 3.19983L6.73926 3.34994ZM6.81036 3.27884L6.86962 3.30649C6.88147 3.31044 6.89332 3.30649 6.89727 3.29859C6.90122 3.28674 6.89727 3.27489 6.88937 3.27094L6.83012 3.24328L6.81036 3.27884Z",
    fill: "#3C9242"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86588 3.41313C6.87773 3.39338 6.89748 3.34598 6.86983 3.33018L6.83032 3.31042C6.87773 3.33413 6.85402 3.38153 6.84612 3.40128",
    fill: "#3C9242"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92871 3.44475L7.05907 3.5198L7.07487 3.49215L6.96821 3.4329L6.98797 3.39734L7.07092 3.4408L7.08672 3.41709L7.00377 3.36969L7.01957 3.34204L7.11833 3.39734L7.13413 3.36969L7.01167 3.29858L6.92871 3.44475Z",
    fill: "#3C9242"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1737 3.52772C7.1658 3.53957 7.1737 3.55933 7.19345 3.57118C7.2132 3.58303 7.22505 3.58303 7.23295 3.57513C7.2527 3.54747 7.14604 3.50402 7.17765 3.45662C7.2053 3.41316 7.2527 3.44872 7.27245 3.45662C7.29221 3.46847 7.31986 3.50007 7.29616 3.53167L7.26455 3.51192C7.27641 3.49612 7.26455 3.48427 7.24875 3.47242C7.23295 3.46057 7.2211 3.45662 7.2132 3.47242C7.1974 3.49612 7.30011 3.53957 7.26851 3.58698C7.24875 3.62253 7.2053 3.60673 7.17765 3.59093C7.15394 3.57513 7.11839 3.53957 7.14209 3.50797L7.1737 3.52772Z",
    fill: "#3C9242"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35172 3.64623C7.33987 3.65808 7.34777 3.67783 7.36752 3.68968C7.38727 3.70548 7.40308 3.70548 7.40703 3.69363C7.42678 3.66598 7.32407 3.61857 7.35962 3.57117C7.39122 3.52772 7.43468 3.56722 7.45443 3.57907C7.47418 3.59092 7.49788 3.62252 7.47418 3.65808L7.44653 3.63833C7.45443 3.62252 7.44653 3.61067 7.43073 3.59882C7.41493 3.58697 7.40307 3.58302 7.39517 3.59882C7.37937 3.62252 7.47813 3.66993 7.44653 3.71733C7.41888 3.75289 7.37937 3.73313 7.35567 3.71733C7.33197 3.70153 7.30037 3.66598 7.32407 3.63043L7.35172 3.64623Z",
    fill: "#3C9242"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51747 3.83582C7.54907 3.86347 7.60043 3.85162 7.62808 3.81607C7.65573 3.78051 7.65573 3.72916 7.62018 3.70546C7.58858 3.67781 7.53722 3.68571 7.50957 3.72521C7.48587 3.76076 7.48587 3.81212 7.51747 3.83582ZM7.53722 3.81212C7.55698 3.82792 7.58858 3.82002 7.60438 3.80027C7.62413 3.77656 7.62018 3.74891 7.60043 3.73311C7.58068 3.71731 7.55302 3.72521 7.53327 3.74496C7.51747 3.76866 7.51747 3.79632 7.53722 3.81212Z",
    fill: "#3C9242"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57448 3.10901L4.55078 3.18407L4.58633 3.19592L4.57448 3.10901Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57459 3.10901L4.5983 3.18407L4.56274 3.19592L4.57459 3.10901Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64561 3.16418H4.57056V3.19974L4.64561 3.16418Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6457 3.16418L4.58645 3.20764L4.56274 3.17604L4.6457 3.16418Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50342 3.16418L4.56267 3.20764L4.58637 3.17604L4.50342 3.16418Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50342 3.16418H4.57847V3.19974L4.50342 3.16418Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61809 3.24713L4.59439 3.17603L4.55884 3.18788L4.61809 3.24713Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61809 3.24718L4.55884 3.20372L4.57859 3.17212L4.61809 3.24718Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53101 3.24718L4.59026 3.20372L4.57051 3.17212L4.53101 3.24718Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53101 3.24713L4.55471 3.17603L4.59026 3.18788L4.53101 3.24713Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72878 3.84766L4.70508 3.91876L4.74063 3.93061L4.72878 3.84766Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72865 3.84766L4.75235 3.91876L4.7168 3.93061L4.72865 3.84766Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79942 3.89893H4.72437V3.93448L4.79942 3.89893Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79975 3.89893L4.7405 3.94238L4.7168 3.91078L4.79975 3.89893Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65747 3.89893L4.71673 3.94238L4.74043 3.91078L4.65747 3.89893Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65747 3.89893H4.73253V3.93448L4.65747 3.89893Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77215 3.98199L4.75239 3.91089L4.71289 3.92274L4.77215 3.98199Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77215 3.98192L4.71289 3.93846L4.73264 3.90686L4.77215 3.98192Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6853 3.98192L4.74456 3.93846L4.72481 3.90686L4.6853 3.98192Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6853 3.98199L4.70901 3.91089L4.74456 3.92274L4.6853 3.98199Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51507 4.02942L4.49927 4.07682L4.52297 4.08472L4.51507 4.02942Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51523 4.02942L4.53103 4.07682L4.50732 4.08472L4.51523 4.02942Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56259 4.06494H4.51123V4.08864L4.56259 4.06494Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56263 4.06494L4.52313 4.09259L4.50732 4.07284L4.56263 4.06494Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46802 4.06494L4.50752 4.09259L4.52332 4.07284L4.46802 4.06494Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46802 4.06494H4.51542V4.08864L4.46802 4.06494Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54292 4.12016L4.52712 4.07275L4.50342 4.08065L4.54292 4.12016Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54292 4.12008L4.50342 4.08848L4.51922 4.06873L4.54292 4.12008Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48755 4.12008L4.52705 4.08848L4.51125 4.06873L4.48755 4.12008Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48755 4.12016L4.4994 4.07275L4.5231 4.08065L4.48755 4.12016Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90248 3.7804L4.89062 3.812L4.90643 3.8199L4.90248 3.7804Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90219 3.7804L4.91009 3.812L4.89429 3.8199L4.90219 3.7804Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93399 3.8042H4.89844V3.82L4.93399 3.8042Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93379 3.8042L4.90614 3.82395L4.89429 3.80815L4.93379 3.8042Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86694 3.8042L4.8946 3.82395L4.90645 3.80815L4.86694 3.8042Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86694 3.8042H4.9025V3.82L4.86694 3.8042Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92194 3.84366L4.91009 3.80811L4.89429 3.81601L4.92194 3.84366Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92194 3.84366L4.89429 3.82391L4.90219 3.80811L4.92194 3.84366Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87866 3.84366L4.90631 3.82391L4.89841 3.80811L4.87866 3.84366Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87866 3.84366L4.89051 3.80811L4.90631 3.81601L4.87866 3.84366Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09592 4.0332L5.07617 4.09246L5.10382 4.10431L5.09592 4.0332Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09584 4.0332L5.11164 4.09246L5.08398 4.10431L5.09584 4.0332Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15134 4.07678H5.08813V4.10839L5.15134 4.07678Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15114 4.07678L5.09979 4.11234L5.08398 4.08863L5.15114 4.07678Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03271 4.07678L5.08407 4.11234L5.10382 4.08863L5.03271 4.07678Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03271 4.07678H5.09592V4.10839L5.03271 4.07678Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13143 4.14385L5.11168 4.08459L5.08008 4.09645L5.13143 4.14385Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13143 4.14385L5.08008 4.1083L5.09588 4.08459L5.13143 4.14385Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05664 4.14385L5.10799 4.1083L5.08824 4.08459L5.05664 4.14385Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05664 4.14385L5.07639 4.08459L5.10404 4.09645L5.05664 4.14385Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04075 4.20703L5.021 4.26629L5.0526 4.27419L5.04075 4.20703Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04066 4.20703L5.06041 4.26629L5.02881 4.27419L5.04066 4.20703Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09983 4.25061H5.03662V4.28221L5.09983 4.25061Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09987 4.25061L5.04852 4.28616L5.03271 4.26246L5.09987 4.25061Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9812 4.25061L5.03256 4.28616L5.05231 4.26246L4.9812 4.25061Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9812 4.25061H5.04441V4.28221L4.9812 4.25061Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07621 4.32163L5.06041 4.25842L5.02881 4.27027L5.07621 4.32163Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07626 4.32163L5.0249 4.28213L5.04465 4.25842L5.07626 4.32163Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00513 4.32163L5.05648 4.28213L5.03673 4.25842L5.00513 4.32163Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00513 4.32163L5.02488 4.25842L5.05253 4.27027L5.00513 4.32163Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54592 2.88379L6.52222 2.9549L6.55777 2.96675L6.54592 2.88379Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54579 2.88379L6.56949 2.9549L6.53394 2.96675L6.54579 2.88379Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61681 2.93518H6.54175V2.97073L6.61681 2.93518Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61689 2.93518L6.55764 2.97863L6.53394 2.94703L6.61689 2.93518Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47461 2.93518L6.53386 2.97863L6.55757 2.94703L6.47461 2.93518Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47461 2.93518H6.54967V2.97073L6.47461 2.93518Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58904 3.01813L6.56534 2.94702L6.52979 2.95887L6.58904 3.01813Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58904 3.01805L6.52979 2.9746L6.54954 2.94299L6.58904 3.01805Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50244 3.01805L6.5617 2.9746L6.54194 2.94299L6.50244 3.01805Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50244 3.01813L6.52614 2.94702L6.5617 2.95887L6.50244 3.01813Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22902 4.04126L7.20532 4.11237L7.24088 4.12422L7.22902 4.04126Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22914 4.04126L7.25284 4.11237L7.21729 4.12422L7.22914 4.04126Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3004 4.09265H7.22534V4.1282L7.3004 4.09265Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30024 4.09265L7.24099 4.1361L7.21729 4.1045L7.30024 4.09265Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1582 4.09265L7.21746 4.1361L7.24116 4.1045L7.1582 4.09265Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1582 4.09265H7.23326V4.1282L7.1582 4.09265Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27658 4.17548L7.24893 4.10437L7.21338 4.11622L7.27658 4.17548Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27658 4.17552L7.21338 4.13207L7.23708 4.10046L7.27658 4.17552Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18555 4.17552L7.2448 4.13207L7.22505 4.10046L7.18555 4.17552Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18555 4.17548L7.20925 4.10437L7.2448 4.11622L7.18555 4.17548Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4741 4.08081L7.45435 4.12821L7.482 4.13612L7.4741 4.08081Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47401 4.08081L7.48981 4.12821L7.46216 4.13612L7.47401 4.08081Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51738 4.11633H7.46997V4.14004L7.51738 4.11633Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51766 4.11633L7.47816 4.14399L7.46631 4.12423L7.51766 4.11633Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42676 4.11633L7.46626 4.14399L7.48206 4.12423L7.42676 4.11633Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42676 4.11633H7.47416V4.14004L7.42676 4.11633Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50166 4.17155L7.48586 4.12415L7.46216 4.13205L7.50166 4.17155Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50166 4.17159L7.46216 4.14394L7.47796 4.12024L7.50166 4.17159Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44238 4.17159L7.48189 4.14394L7.47003 4.12024L7.44238 4.17159Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44238 4.17155L7.45818 4.12415L7.48189 4.13205L7.44238 4.17155Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30027 4.20703L7.28052 4.26629L7.31212 4.27419L7.30027 4.20703Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30038 4.20703L7.32013 4.26629L7.29248 4.27419L7.30038 4.20703Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35959 4.25061H7.29639V4.28221L7.35959 4.25061Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35964 4.25061L7.31223 4.28616L7.29248 4.26246L7.35964 4.25061Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24097 4.25061L7.29232 4.28616L7.31207 4.26246L7.24097 4.25061Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24097 4.25061H7.30417V4.28221L7.24097 4.25061Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33573 4.32163L7.31993 4.25842L7.28833 4.27027L7.33573 4.32163Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33573 4.32163L7.28833 4.28213L7.30413 4.25842L7.33573 4.32163Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26465 4.32163L7.316 4.28213L7.29625 4.25842L7.26465 4.32163Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26465 4.32163L7.2844 4.25842L7.31205 4.27027L7.26465 4.32163Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87742 4.57446L6.85767 4.63372L6.88927 4.64162L6.87742 4.57446Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87753 4.57446L6.89728 4.63372L6.86963 4.64162L6.87753 4.57446Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9367 4.61804H6.87744V4.64964L6.9367 4.61804Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93678 4.61804L6.88938 4.65359L6.86963 4.62989L6.93678 4.61804Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82227 4.61804L6.86967 4.65359L6.88942 4.62989L6.82227 4.61804Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82227 4.61804H6.88152V4.64964L6.82227 4.61804Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91337 4.68511L6.89757 4.62585L6.86597 4.63771L6.91337 4.68511Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91337 4.68511L6.86597 4.64956L6.88177 4.62585L6.91337 4.68511Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84204 4.68511L6.8934 4.64956L6.87364 4.62585L6.84204 4.68511Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84204 4.68511L6.86179 4.62585L6.8934 4.63771L6.84204 4.68511Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87762 4.76416L6.86182 4.80761L6.88552 4.81946L6.87762 4.76416Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87753 4.76416L6.89333 4.80761L6.86963 4.81946L6.87753 4.76416Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92513 4.79578H6.87378V4.82343L6.92513 4.79578Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92493 4.79578L6.88148 4.82738L6.86963 4.80763L6.92493 4.79578Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83032 4.79578L6.86983 4.82738L6.88563 4.80763L6.83032 4.79578Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83032 4.79578H6.87773V4.82343L6.83032 4.79578Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90547 4.85095L6.88967 4.8075L6.86597 4.81145L6.90547 4.85095Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90547 4.85111L6.86597 4.82346L6.88177 4.80371L6.90547 4.85111Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84595 4.85111L6.8894 4.82346L6.8736 4.80371L6.84595 4.85111Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84595 4.85095L6.86175 4.8075L6.88545 4.81145L6.84595 4.85095Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0554 4.44812L7.03564 4.49552L7.05935 4.50342L7.0554 4.44812Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05555 4.44812L7.0674 4.49552L7.0437 4.50342L7.05555 4.44812Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09867 4.48364H7.05127V4.50734L7.09867 4.48364Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09901 4.48364L7.0595 4.51129L7.0437 4.49154L7.09901 4.48364Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00391 4.48364L7.04736 4.51129L7.05921 4.49154L7.00391 4.48364Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00391 4.48364H7.05526V4.50734L7.00391 4.48364Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0832 4.53886L7.0674 4.49146L7.0437 4.49936L7.0832 4.53886Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0832 4.53903L7.0437 4.50742L7.0595 4.48767L7.0832 4.53903Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02368 4.53903L7.06319 4.50742L7.05133 4.48767L7.02368 4.53903Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02368 4.53886L7.03948 4.49146L7.06319 4.49936L7.02368 4.53886Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19358 4.34937L7.17383 4.40467L7.20148 4.41652L7.19358 4.34937Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19349 4.34937L7.21324 4.40467L7.18164 4.41652L7.19349 4.34937Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2529 4.38879H7.1897V4.4204L7.2529 4.38879Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2527 4.38879L7.20135 4.4283L7.18555 4.40065L7.2527 4.38879Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13428 4.38879L7.18563 4.4283L7.20143 4.40065L7.13428 4.38879Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13428 4.38879H7.19748V4.4204L7.13428 4.38879Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22905 4.45989L7.21324 4.40063L7.18164 4.41249L7.22905 4.45989Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22933 4.45993L7.17798 4.42438L7.19773 4.39673L7.22933 4.45993Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1582 4.45993L7.20956 4.42438L7.18981 4.39673L7.1582 4.45993Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1582 4.45989L7.17795 4.40063L7.20561 4.41249L7.1582 4.45989Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86952 4.4165L6.85767 4.46391L6.88137 4.47181L6.86952 4.4165Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86972 4.4165L6.88947 4.46391L6.86182 4.47181L6.86972 4.4165Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92098 4.44812H6.86963V4.47577L6.92098 4.44812Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92127 4.44812L6.87782 4.47972L6.86597 4.45602L6.92127 4.44812Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82617 4.44812L6.86568 4.47972L6.87753 4.45602L6.82617 4.44812Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82617 4.44812H6.87358V4.47577L6.82617 4.44812Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90132 4.50729L6.88552 4.45593L6.86182 4.46383L6.90132 4.50729Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90132 4.50729L6.86182 4.47568L6.87367 4.45593L6.90132 4.50729Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84204 4.50729L6.88154 4.47568L6.86969 4.45593L6.84204 4.50729Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84204 4.50729L6.85784 4.45593L6.88154 4.46383L6.84204 4.50729Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33713 3.50781L5.31738 3.56707L5.34899 3.57892L5.33713 3.50781Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33705 3.50781L5.3568 3.56707L5.3252 3.57892L5.33705 3.50781Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39621 3.55139H5.33301V3.58299L5.39621 3.55139Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39626 3.55139L5.3449 3.59089L5.3291 3.56324L5.39626 3.55139Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27759 3.55139L5.32894 3.59089L5.34474 3.56324L5.27759 3.55139Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27759 3.55139H5.33684V3.58299L5.27759 3.55139Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3726 3.62249L5.35285 3.56323L5.3252 3.57113L5.3726 3.62249Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3724 3.62241L5.32104 3.58686L5.3408 3.5592L5.3724 3.62241Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29761 3.62241L5.34896 3.58686L5.33316 3.5592L5.29761 3.62241Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29761 3.62249L5.31736 3.56323L5.34896 3.57113L5.29761 3.62249Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47845 3.36169L6.46265 3.4091L6.48635 3.417L6.47845 3.36169Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4786 3.36169L6.49441 3.4091L6.4707 3.417L6.4786 3.36169Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52592 3.39734H6.47852V3.42104L6.52592 3.39734Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52601 3.39734L6.4865 3.42499L6.4707 3.40524L6.52601 3.39734Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43115 3.39734L6.47066 3.42499L6.48646 3.40524L6.43115 3.39734Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43115 3.39734H6.48251V3.42104L6.43115 3.39734Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51021 3.45256L6.49045 3.40515L6.4707 3.41305L6.51021 3.45256Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51025 3.4526L6.4668 3.421L6.4826 3.40125L6.51025 3.4526Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45093 3.4526L6.49043 3.421L6.47463 3.40125L6.45093 3.4526Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45093 3.45256L6.46673 3.40515L6.49043 3.41305L6.45093 3.45256Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00466 4.21118L5.98096 4.28229L6.01651 4.29414L6.00466 4.21118Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00477 4.21118L6.02452 4.28229L5.99292 4.29414L6.00477 4.21118Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07554 4.26245H6.00049V4.30195L6.07554 4.26245Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07588 4.26245L6.01267 4.3059L5.99292 4.2743L6.07588 4.26245Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93335 4.26245L5.9926 4.3059L6.01236 4.2743L5.93335 4.26245Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93335 4.26245H6.00446V4.30195L5.93335 4.26245Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04802 4.3454L6.02432 4.27429L5.98877 4.28614L6.04802 4.3454Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04807 4.3454L5.98486 4.30194L6.00856 4.27429L6.04807 4.3454Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95703 4.3454L6.02024 4.30194L5.99653 4.27429L5.95703 4.3454Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95703 4.3454L5.98073 4.27429L6.01629 4.28614L5.95703 4.3454Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20603 3.87524L6.18628 3.9345L6.21788 3.94635L6.20603 3.87524Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20594 3.87524L6.22569 3.9345L6.19409 3.94635L6.20594 3.87524Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26511 3.91882H6.2019V3.95043L6.26511 3.91882Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2652 3.91882L6.21384 3.95438L6.19409 3.93067L6.2652 3.91882Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14673 3.91882L6.19808 3.95438L6.21388 3.93067L6.14673 3.91882Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14673 3.91882H6.20993V3.95043L6.14673 3.91882Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2415 3.9898L6.22174 3.93054L6.19409 3.93844L6.2415 3.9898Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24154 3.98984L6.19019 3.95034L6.20994 3.92664L6.24154 3.98984Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1665 3.98984L6.21786 3.95034L6.20206 3.92664L6.1665 3.98984Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1665 3.9898L6.18626 3.93054L6.21786 3.93844L6.1665 3.9898Z",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00461 3.71716L5.98486 3.77642L6.01251 3.78827L6.00461 3.71716Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00477 3.71716L6.02057 3.77642L5.99292 3.78827L6.00477 3.71716Z",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06369 3.76074H6.00049V3.79235L6.06369 3.76074Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06403 3.76074L6.01267 3.7963L5.99292 3.77259L6.06403 3.76074Z",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94507 3.76074L5.99642 3.7963L6.01222 3.77259L5.94507 3.76074Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94507 3.76074H6.00432V3.79235L5.94507 3.76074Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04032 3.83184L6.02057 3.77258L5.99292 3.78048L6.04032 3.83184Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04012 3.83176L5.98877 3.79621L6.00852 3.76855L6.04012 3.83176Z",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96484 3.83176L6.0162 3.79621L5.99645 3.76855L5.96484 3.83176Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M5.96484 3.83184L5.9846 3.77258L6.0162 3.78048L5.96484 3.83184Z",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82684 3.88708L5.81104 3.93449L5.83474 3.94239L5.82684 3.88708Z",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82675 3.88708L5.84255 3.93449L5.81885 3.94239L5.82675 3.88708Z",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87435 3.92273H5.823V3.94643L5.87435 3.92273Z",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87415 3.92273L5.83465 3.95038L5.81885 3.93063L5.87415 3.92273Z",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77954 3.92273L5.81904 3.95038L5.83485 3.93063L5.77954 3.92273Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77954 3.92273H5.83089V3.94643L5.77954 3.92273Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8544 3.97795L5.84255 3.93054L5.81885 3.93844L5.8544 3.97795Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85444 3.97795L5.81494 3.95029L5.83074 3.93054L5.85444 3.97795Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79932 3.97795L5.83882 3.95029L5.82302 3.93054L5.79932 3.97795Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79932 3.97795L5.81512 3.93054L5.83487 3.93844L5.79932 3.97795Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91366 4.02539L5.90576 4.05699L5.92156 4.06489L5.91366 4.02539Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91362 4.02539L5.92547 4.05699L5.90967 4.06489L5.91362 4.02539Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94937 4.04907H5.91382V4.06487L5.94937 4.04907Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94917 4.04907L5.92152 4.06882L5.90967 4.05697L5.94917 4.04907Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88208 4.04907L5.90973 4.06882L5.92158 4.05697L5.88208 4.04907Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88208 4.04907H5.91763V4.06487L5.88208 4.04907Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93341 4.08865L5.92551 4.0531L5.90576 4.061L5.93341 4.08865Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93341 4.08865L5.90576 4.0689L5.91761 4.0531L5.93341 4.08865Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8938 4.08865L5.92145 4.0689L5.91355 4.0531L5.8938 4.08865Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8938 4.08865L5.90565 4.0531L5.92145 4.061L5.8938 4.08865Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5261 4.61804L6.50635 4.6773L6.53795 4.6852L6.5261 4.61804Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52601 4.61804L6.54576 4.6773L6.51416 4.6852L6.52601 4.61804Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58542 4.65747H6.52222V4.69302L6.58542 4.65747Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58522 4.65747L6.53387 4.69697L6.51807 4.66932L6.58522 4.65747Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4668 4.65747L6.51815 4.69697L6.5379 4.66932L6.4668 4.65747Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4668 4.65747H6.53V4.69302L6.4668 4.65747Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56551 4.72857L6.54576 4.66931L6.51416 4.68116L6.56551 4.72857Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56551 4.72857L6.51416 4.69301L6.52996 4.66931L6.56551 4.72857Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49048 4.72857L6.54183 4.69301L6.52208 4.66931L6.49048 4.72857Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49048 4.72857L6.51023 4.66931L6.53788 4.68116L6.49048 4.72857Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6762 4.47583L6.6604 4.52323L6.6841 4.53113L6.6762 4.47583Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67587 4.47583L6.69167 4.52323L6.66797 4.53113L6.67587 4.47583Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72347 4.50732H6.67212V4.53103L6.72347 4.50732Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72327 4.50732L6.68377 4.53893L6.66797 4.51918L6.72327 4.50732Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62866 4.50732L6.66817 4.53893L6.68397 4.51918L6.62866 4.50732Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62866 4.50732H6.68002V4.53103L6.62866 4.50732Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70747 4.56266L6.69167 4.51526L6.66797 4.52316L6.70747 4.56266Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70747 4.56266L6.66797 4.53501L6.67982 4.51526L6.70747 4.56266Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64844 4.56266L6.68794 4.53501L6.67214 4.51526L6.64844 4.56266Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64844 4.56266L6.66424 4.51526L6.68794 4.52316L6.64844 4.56266Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38763 4.43225L6.37183 4.47966L6.39553 4.48756L6.38763 4.43225Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38778 4.43225L6.40358 4.47966L6.37988 4.48756L6.38778 4.43225Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4351 4.46375H6.3877V4.4914L6.4351 4.46375Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43519 4.46375L6.39568 4.49535L6.37988 4.4756L6.43519 4.46375Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34033 4.46375L6.37984 4.49535L6.39564 4.4756L6.34033 4.46375Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34033 4.46375H6.39169V4.4914L6.34033 4.46375Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41939 4.52323L6.40358 4.47583L6.37988 4.48373L6.41939 4.52323Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41943 4.52316L6.37598 4.49155L6.39178 4.4718L6.41943 4.52316Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35986 4.52316L6.39937 4.49155L6.38356 4.4718L6.35986 4.52316Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35986 4.52323L6.37566 4.47583L6.39937 4.48373L6.35986 4.52323Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30129 4.35327L5.27759 4.42438L5.31314 4.43623L5.30129 4.35327Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30116 4.35327L5.32091 4.42438L5.28931 4.43623L5.30116 4.35327Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37266 4.40454H5.29761V4.44404L5.37266 4.40454Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37226 4.40454L5.30906 4.44799L5.28931 4.42034L5.37226 4.40454Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22632 4.40454L5.28952 4.44799L5.30928 4.42034L5.22632 4.40454Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22632 4.40454H5.30533V4.44404L5.22632 4.40454Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3449 4.49152L5.3212 4.42041L5.28564 4.42831L5.3449 4.49152Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3449 4.49156L5.28564 4.44416L5.3054 4.4165L5.3449 4.49156Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25806 4.49156L5.31731 4.44416L5.29361 4.4165L5.25806 4.49156Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25806 4.49152L5.28176 4.42041L5.31731 4.42831L5.25806 4.49152Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00448 4.84314L5.99658 4.86684L6.00448 4.87079V4.84314Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00444 4.84314L6.00839 4.86684L6.00049 4.87079L6.00444 4.84314Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02814 4.86279H6.00049V4.87464L6.02814 4.86279Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02814 4.86279L6.00444 4.87464L6.00049 4.86674L6.02814 4.86279Z",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98096 4.86279L6.00071 4.87464L6.00466 4.86674L5.98096 4.86279Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98096 4.86279H6.00466V4.87464L5.98096 4.86279Z",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01633 4.89052L6.00843 4.86682L5.99658 4.87077L6.01633 4.89052Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01633 4.89052L5.99658 4.87472L6.00448 4.86682L6.01633 4.89052Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98877 4.89052L6.00852 4.87472L6.00062 4.86682L5.98877 4.89052Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98877 4.89052L5.99667 4.86682L6.00852 4.87077L5.98877 4.89052Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtBr);
export default __webpack_public_path__ + "static/media/pt-BR.c00b4e4a363073e5829d9888ef257b31.svg";
export { ForwardRef as ReactComponent };